// 🌑 Grassrooted Unified Visualization System

export const GRASSROOTED_VIZ_PALETTE = [
  "#00FFA3", // Primary civic accent (small dollar)
  "#3B82F6", // Institutional blue (large donor)
  "#F59E0B", // Amber (PAC)
  "#A78BFA", // Violet (self-funding)
  "#F43F5E", // Controlled red (other candidates)
  "#22D3EE", // Cyan (other)
  ];
  
  export const GRASSROOTED_NEUTRALS = {
    primary: "#94A3B8",
    muted: "#64748B",
    soft: "rgba(148,163,184,0.25)"
  };
  
  export const GRASSROOTED_ACCENT = {
    primary: "#00D084",
    soft: "rgba(0, 208, 132, 0.15)"
  };
  
  export const GRASSROOTED_STATES = {
    hoverBrightness: 0.08,
    inactiveOpacity: 0.35
  };